export default {"src":"/sg/_next/static/media/jd-Mini.6dcccc64.svg","height":150,"width":63,"blurWidth":0,"blurHeight":0};